<template>
  <el-popover
      trigger="hover"
      popper-class="tooltip"
      :disabled="!_tooltip"
      placement="left"
      :open-delay="500"
      :close-delay="1000"
      @created="handlePopupCreated">
    <template #reference>
      <v-icon :color="_iconColor" :small="small" :x-small="xSmall">{{ _icon }}</v-icon>
    </template>
    <template #default>
      <slot name="tooltip-prepend"></slot>
      <slot name="tooltip" v-bind:tooltip="_tooltip">{{ _tooltip }}</slot>
      <slot name="tooltip-append"></slot>
    </template>
  </el-popover>
</template>

<script>
export default {
  name: "UpdateIcon",
  props: {
    type: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    xSmall: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      popovers: []
    };
  },
  beforeDestroy() {
    for(const popover of this.popovers) {
      popover.doClose();
      popover.doDestroy();
    }
  },
  computed: {
    _tooltip() {
      switch(this.type) {
        case 'add':     return '新規に作成されます';
        case 'update':  return '更新があります';
        case 'stay':    return '更新がありません';
        case 'deleted': return '削除されています';
        default:        return '';
      }
    },
    _icon() {
      switch(this.type) {
        case 'add':     return 'mdi-plus-thick';
        case 'update':  return 'mdi-arrow-top-right-thick';
        case 'stay':    return 'mdi-minus-thick';
        case 'deleted': return 'mdi-close-thick';
        default:        return '';
      }
    },
    _iconColor() {
      switch(this.type) {
        case 'add':     return 'deep-orange darken-1';
        case 'update':  return 'orange darken-1';
        case 'stay':    return 'light-blue darken-1';
        case 'deleted': return 'red darken-3';
        default:        return 'transparent';
      }
    }
  },
  methods: {
    handlePopupCreated(popover) {
      document.querySelector('#app').appendChild(popover.popperElm);
      this.popovers.push(popover);
    }
  }
}
</script>

